import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import PropTypes from 'prop-types';

import {sendToParent, TYPES} from '../../common/events';

const handleFormClose = () => {
  sendToParent(TYPES.CLOSE);
};

class BackButton extends Component {
  render() {
    const {intl, isIFrame} = this.props;

    return (
      <div>
        {isIFrame ? (
          <a className="form-button button-link button-link__active" onClick={handleFormClose}>
            {intl.messages['app.close']}
          </a>
        ) : (
          <div className="message">{intl.messages['app.close']}</div>
        )}
      </div>
    );
  }
}

BackButton.propTypes = {
  isIFrame: PropTypes.bool.isRequired,
  intl: PropTypes.object
};

export default injectIntl(BackButton);



// WEBPACK FOOTER //
// ./components/BackButton.jsx